<footer class="flex h-[78px] w-full justify-center gap-4 bg-pl-black p-4 text-white">
  <div class="w-footer border-t border-[#ffffff66] pt-4">
    <p class="text-lg">© {{ currentYear }} {{ 'utils.all_right_reserved' | translate }}</p>
  </div>
</footer>
